<template>
  <v-layout>
    <v-dialog v-model="dialogVisible" max-width="500px" persistent @click:outside="closeDialog">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="print">
          <v-card-title class="headline">
            Imprimir Etiqueta
          </v-card-title>

          <v-card-text>
            <div v-if="loading" class="text-center py-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>

            <div v-else>
              <v-row>
                <v-col cols="12">
                  <div class="mb-3">
                    <strong>Orden de Producción:</strong> #{{ productionOrder ? productionOrder.id : '' }}
                  </div>
                  <div class="mb-3">
                    <strong>Fórmula:</strong> {{ productionOrder && productionOrder.formula ? productionOrder.formula.name : '' }}
                  </div>
                </v-col>
              </v-row>

              <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.number="quantity"
                  label="Cantidad de etiquetas*"
                  type="number"
                  min="1"
                  dense
                  :disabled="saving"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="observaciones"
                  label="Observaciones (opcional)"
                  dense
                  rows="3"
                  :disabled="saving"
                ></v-textarea>
              </v-col>
            </v-row>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialog" :disabled="saving">
              Cancelar
            </v-btn>
            <v-btn 
              color="success" 
              text 
              type="submit"
              :loading="saving"
              :disabled="saving"
            >
              Imprimir
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { productionOrderService } from "@/libs/ws/productionOrderService";

export default {
  name: 'ModalPrintLabel',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    productionOrder: {
      type: Object,
      default: null
    },
    initialObservaciones: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      quantity: 1,
      observaciones: '',
      saving: false,
      loading: false,
    };
  },
  watch: {
    dialog(val) {
      this.dialogVisible = val;
      if (val) {
        this.loadLastObservation();
      }
    }
  },
  methods: {
    async loadLastObservation() {
      if (!this.productionOrder || !this.productionOrder.id) {
        this.resetForm();
        return;
      }

      // Si viene initialObservaciones como prop, usarla directamente
      if (this.initialObservaciones !== null) {
        this.observaciones = this.initialObservaciones;
        this.quantity = 1;
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
        return;
      }

      this.loading = true;
      
      try {
        const response = await productionOrderService.getInternalStateHistory(this.productionOrder.id);
        
        if (response.status && response.result && response.result.length > 0) {
          // El primer elemento es el más reciente (ordenado DESC en backend)
          const lastHistory = response.result[0];
          this.observaciones = lastHistory.observaciones || '';
        } else {
          this.observaciones = '';
        }
        
        this.quantity = 1;
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      } catch (error) {
        console.error('Error al cargar última observación:', error);
        this.resetForm();
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.quantity = 1;
      this.observaciones = '';
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit('updateDialog', false);
    },
    print() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.saving = true;

      const data = {
        production_order_id: this.productionOrder.id,
        quantity: this.quantity,
        observaciones: this.observaciones
      };

      this.$emit('print', data);
      
      // Simular delay de impresión
      setTimeout(() => {
        this.saving = false;
        this.closeDialog();
      }, 500);
    }
  }
};
</script>

<style scoped>
.headline {
  background-color: #f5f5f5;
}
</style>
